var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"micad_resultsList"},_vm._l((_vm.results),function(result){return _c('li',{key:result,staticClass:"micad_resultsList_result"},[_vm._v(_vm._s(result))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }